import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Tiktok({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18.3115 6.00888C17.1997 5.30628 16.397 4.1826 16.1468 2.87257C16.0927 2.58939 16.0631 2.2982 16.0631 2H12.5144L12.5085 15.7801C12.4489 17.3232 11.1382 18.5618 9.5312 18.5618C9.03182 18.5618 8.56139 18.4409 8.14749 18.2295C7.19801 17.7453 6.54837 16.7809 6.54837 15.6713C6.54837 14.0774 7.8866 12.7807 9.5312 12.7807C9.83827 12.7807 10.1326 12.8298 10.4114 12.9143V9.40399C10.1229 9.36593 9.83 9.34222 9.5312 9.34222C5.9301 9.34255 3 12.1817 3 15.6713C3 17.8125 4.10421 19.7072 5.78845 20.8529C6.84924 21.5746 8.1399 22 9.53154 22C13.133 22 16.0631 19.1609 16.0631 15.6713V8.6837C17.4547 9.65177 19.16 10.2221 21 10.2221V6.78361C20.0088 6.78361 19.0855 6.4981 18.3115 6.00888Z" fill="currentColor" /></Svg>;
}
export default Tiktok;